import { LAB_REPORT } from "@/api_framework/api_config";
import { useConfiguration } from "@/app/hooks/useConfiguration";
import { useCurlLogger } from "@/app/hooks/useCurlLogger";
import { useAppDispatch } from "@/app_redux/hooks/root_hook";
import axios, { AxiosError, AxiosResponse } from "axios";
import AxiosCurlirize from "axios-curlirize";
import { useCallback } from "react";
import { useAPIUtils } from "../../useAPIUtils";
import toast from "react-hot-toast";

AxiosCurlirize(axios, () => {});
type ICartAPIResponse = { status: boolean; message: string };

export const useLabClinicMappingAPI = () => {
  const configuration = useConfiguration();

  const dispatch = useAppDispatch();
  const { captureError } = useAPIUtils();
  const { sendCurl } = useCurlLogger();

  const execute = useCallback(
    async (bodyParams: any, clinic_id: string) => {
      try {
        const accessToken = localStorage.getItem(configuration.localStorage.ACCESS_TOKEN.key);
        const response: ICartAPIResponse = await axios
          .post(`${LAB_REPORT?.CLINIC_LAB_MAPPING?.baseURL}${clinic_id}/`, bodyParams, {
            headers: {
              Authorization: `${accessToken}`,
              "Content-Type": "application/json",
            },
          })
          .then((res: AxiosResponse<any>) => {
            if (res.data.status === true) {
              toast.success(res.data.message);
              return { status: true, message: res.data?.data };
            } else {
              return { status: false, message: null };
            }
          })
          .catch((e: AxiosError) => {
            sendCurl(e.config["curlCommand"]);
            captureError(e);
            return { status: false, message: null };
          });
        return response;
      } catch (e: any) {
        captureError(e);
      }
    },
    [dispatch],
  );
  return { execute };
};
